/** @format */

import { cn, Tooltip, TooltipContent, TooltipTrigger } from '@clarix/ui';
import { getRoleColor } from '@clarix/utils';

interface RoleChipProps {
  roleName: string | null | undefined;
  className?: string;
}

export function RoleChip({ roleName, className }: RoleChipProps) {
  const label = roleName?.trim() ? roleName : 'No role';
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'inline-flex max-w-full items-center rounded-full px-2 py-0.5 text-lg font-medium',
            getRoleColor(roleName),
            className,
          )}
        >
          <span className="truncate">{label}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{label}</p>
      </TooltipContent>
    </Tooltip>
  );
}
